import { h } from 'preact';
import cx from 'classnames';

import { ContainerFluid } from '@cube/layout';
import { MobileHeader } from '@cube/header-widget';

import { SadlibAd } from '../../../../pieces/sadlib-ad';

import style from '../../shared/style.less';

export const Phone = ({ pageConfig, ...props }) => (
	<ContainerFluid class={style.joinClass}>
		<MobileHeader {...props} {...pageConfig.header} />
		<div class={cx(style.section)}>
			<div
				className={style.embedTarget}
				id="getSetUpEmbedTarget"
			/>
		</div>
		<SadlibAd id="adhesion" />
	</ContainerFluid>
);
